import React from 'react';
import TokenReferenceButton from '../Common/TokenReferenceButton';
import { useWebhookTokens } from './useWebhookTokens';

// "Available Tokens" for a webhook's request body. Thin wrapper over the shared reference button:
// all this adds is the webhook-type-to-context mapping and the wording, since which tokens exist
// depends on which event fires. A type with no token pass renders nothing.

interface IWebhookTokenReferenceProps {
    type?: string;
}

const WebhookTokenReference: React.FC<IWebhookTokenReferenceProps> = ({ type }) => {
    const { context, supported } = useWebhookTokens(type);
    if (!supported || !context) return null;
    return (
        <TokenReferenceButton
            iconOnly
            context={context}
            description='Copy a token into the request body; it is replaced with the corresponding value when this webhook fires. The body field also suggests them as you type an opening brace. Tokens are per event, so this list changes with the webhook type.'
        />
    );
};

export default WebhookTokenReference;
